import { PlanSection } from '@/features/billing/PlanSection'
import { PlanUsageSection } from '@/features/billing/PlanUsage'

/**
 * Predplatné školy - balíček (zmena, objednávka, požiadavka) a jeho využitie
 * v sezóne. Zmluvy, faktúry a VOP sú v Dokumentoch; tu je to, čo škola
 * mení, tam archív.
 */
export default function SubscriptionTab() {
  return (
    <div className="max-w-4xl space-y-8">
      <PlanSection />
      <PlanUsageSection />
    </div>
  )
}
